/**
* @name: menu-li-record
* @author: weiyong
* @date: 2023-05-16 18:30
* @description：menu-li-record
* @update: 2023-05-16 18:30
*/
<template>
  <div class="menu-li flex-div-bet w100b"
       :class="[isCollectItemFlag?'collectItem':'notCollectItem',activeMenuId===item.id?'active-menu':'not-active-menu']">
    <div class="menu-main-area flex-div">
      <div class="icon-div"><i :class="item.source"></i></div>
      <div style="padding: 0 6px;">
        {{ item.label || item.name }}
      </div>
    </div>
    <div class="addLoveMenu" @click.stop="collectMenu(item)">
      <span class="loverMenuIcon"
            :class="isCollectItemFlag?'remix-icon ri-star-fill':'remix-icon ri-star-line1'"></span>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "menu-li-record",
});
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";

const {prefixCls} = useDesign('menu-li-record');

const props = defineProps({
  item: {},
  isCollectItemFlag: {}
})

const menuStore = useMenuStore();
const {
  activeMenuId,
}: any = storeToRefs(menuStore)

const emits = defineEmits(['collectMenuClick'])
const collectMenu = function (item) {
  emits('collectMenuClick', item, props.isCollectItemFlag);
}

</script>

<style type="text/css" lang="less">

.menu-li.collectItem {
  border-radius: 6px;
  height: 100%;
  display: flex;
  align-items: center;
}

.menu-li {

  &.active-menu {
    background-color: #F0F0F0;
    color: var(--primary-color, #0a6eff);
  }

  &.collectItem {
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 0 12px;

    .loverMenuIcon {
      display: block;
      color: #F1B51D;
    }
  }

  &.notCollectItem {
    padding: 8px 12px;
    border-radius: 6px;
  }

  .addLoveMenu {
    padding-right: 8px;
  }

  .loverMenuIcon {
    display: none;
  }

  &:hover {
    background-color: #F0F0F0;
    padding: 8px 12px;
    border-radius: 6px;

    .loverMenuIcon {
      display: block;
    }
  }
}

</style>
